export const vehicleDetailNames = [
  "Vehicle Number",
  "MOT Expiry",
  "Vehicle Status",
  "Registration Date",
  "Your Vehicle",
];
export const vehicleInfoNames = [
  "Vehicle Make",
  "Year of Manufacture",
  "Vehicle Colour",
  "Tax Due Date",
  "Date of Last V5C Logbook",
];
export const motInfoNames = [
  "MOT Test Date",
  "MOT Expiry Date",
  "Test Result",
  "Vehicle ID",
  "MOT Test Number",
];

export const vehicleDetails = [
  "BF76 HJH",
  "01/01/2022",
  "Taxed",
  "01/01/2020",
  "Insured",
];
export const vehicleInfo = [
  "ZAVHAULL",
  "July 2020",
  "Metallic",
  "01/10/2021",
  "01/10/2020",
];
export const motInfo = [
  "10/09/2019",
  "01/10/2022",
  "Metallic",
  "01/10/2021",
  "01/10/2020",
];
